<template>
  <NtModal ref="modal" class="relative" @closed="$emit('closed')">
    <div
      class="absolute left-1/2 -top-10 -translate-x-1/2 w-20 h-20 rounded-md bg-accent-600 flex items-center justify-center text-3xl text-accent-text">
      <i class="fa-sharp fa-fw" :class="localAlert.icon" aria-hidden="true"></i>
    </div>

    <NtSpacing class="mt-8 text-center">
      <NtHeading>{{ localAlert.title }}</NtHeading>
      <NtWysiwygPresenter :html="localAlert.description" />
    </NtSpacing>

    <NtFullScreenEffect ref="effect" :effect="localAlert.full_screen_effect" />

    <template v-slot:footer>
      <NtButton v-if="url" level="primary" icon="fa-arrow-right" :[urlAttr]="url" @click="close">
        {{ localAlert.btn_label }}
      </NtButton>
      <NtButton level="secondary" icon="fa-times" @click="close"> Dismiss </NtButton>
    </template>
  </NtModal>
</template>

<script>
import NtModal from '../../general/NtModal.vue'
import NtHeading from '../../general/NtHeading.vue'
import NtWysiwygPresenter from '../../general/NtWysiwygPresenter.vue'
import NtButton from '../../general/NtButton.vue'
import NtSpacing from '../../general/NtSpacing.vue'
import NtFullScreenEffect from '../../general/NtFullScreenEffect.vue'

export default {
  components: { NtModal, NtHeading, NtWysiwygPresenter, NtButton, NtSpacing, NtFullScreenEffect },
  emits: ['closed'],
  props: {
    autoOpen: {
      type: Boolean,
      default: false
    },
    alert: {
      type: [Object, null],
      required: true
    }
  },
  data() {
    return {
      localAlert: this.alert
    }
  },
  computed: {
    url() {
      if (!this.localAlert?.btn_url) {
        return null
      }

      return this.localAlert.btn_url.startsWith(window.location.origin) || this.localAlert.btn_url.startsWith('/')
        ? this.localAlert.btn_url.replace(window.location.origin, '')
        : this.localAlert.btn_url
    },
    urlAttr() {
      return this.url?.startsWith('http') ? 'href' : 'to'
    }
  },
  mounted() {
    this.tryOpen()
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    tryOpen() {
      if (this.localAlert && this.autoOpen) {
        this.open()
      }
    }
  },
  watch: {
    alert(val) {
      if (val) {
        this.localAlert = val
        this.tryOpen()
        return
      }

      this.close()
    }
  }
}
</script>
